import type { PropsWithChildren } from 'react';

import Stack from '@mui/material/Stack';
import Textarea from 'shared/components/Textarea';

import styled from 'shared/utils/styled';

export const StyledTextarea = styled(Textarea)(() => ({
  minHeight: 175,
}));

export const CheckboxContainer = ({ children }: PropsWithChildren<{}>) => (
  <Stack direction="row" spacing={1.5}>
    {children}
  </Stack>
);

export const Label = styled('span')(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.primary.main,
}));
